// import axios from 'axios'
import {get,post} from '../libs/ajax.js'
// vivo批量创建-列表-搜索下拉结果   //http://127.0.0.1:4523/m1/1919333-0-default
export const GET_SEARCH_LIST = (data, options) => {
    return get('/vivo/batch/get_search_list', data, options)
}
// vivo批量创建-列表-列表汇总数据
export const GET_TOTAL = (data,options) => {
    return get('/vivo/batch/get_total', data, options)
}
// vivo批量创建-列表-列表数据
export const GET_LIST = (data,options) => {
    return get('/vivo/batch/get_list', data, options)
}
// vivo批量创建-列表-列表数据
export const GET_TARGET_ACCOUNT = (data,options) => {
    return get('/vivo/batch/get_target_account', data, options)
}
// vivo批量创建-详情列表-搜索下拉结果
export const GET_DETAIL_SEARCH_LIST = (data,options) => {
    return get('/vivo/batch/get_detail_search_list', data, options)
}
// vivo批量创建-详情列表-列表汇总数据
export const GET_DETAIL_TOTAL = (data,options) => {
    return get('/vivo/batch/get_detail_total', data, options)
}
// vivo批量创建-详情列表-列表数据
export const GET_DETAIL = (data,options) => {
    return get('/vivo/batch/get_detail', data, options)
}
// vivo批量创建-详情列表-列表数据-创意列表
export const GET_DETAIL_IDEA_LIST = (data,options) => {
    return get('/vivo/batch/get_detail_idea_list', data, options)
}
// vivo批量创建-详情列表-列表数据-创意列表
export const TASK_RETRY = (data,options) => {
    return post('/vivo/batch/task_retry', data, options)
}

export const getSmartProductDetailIdeaListApi = (data,options) => {
    return get('/vivo/batch/get_smart_product_detail_idea_list', data, options)
}
